import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { valueof } from '@/types';
import { checkoutRedirectUrl } from '@/redux/thunks/checkout/index';
import { STEPS } from '@/constants/checkout';

export const redirectToAnotherStep = createAppAsyncThunk(
  'checkout/redirectToAnotherStep',
  async (stepToRedirect: valueof<typeof STEPS>) => {
    await checkoutRedirectUrl(`/${stepToRedirect}`);
  }
);
